import { render, staticRenderFns } from "./OnePageReturn.vue?vue&type=template&id=84775ac6&scoped=true&"
import script from "./OnePageReturn.vue?vue&type=script&lang=js&"
export * from "./OnePageReturn.vue?vue&type=script&lang=js&"
import style0 from "./OnePageReturn.vue?vue&type=style&index=0&id=84775ac6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84775ac6",
  null
  
)

export default component.exports